import { TExperiment } from '../../types/experiments';
import { TWidgetState } from '../../types/widgetState';

export const selectExperiments = (state: TWidgetState): TExperiment[] => state.experiments;
